import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/Button'; // Assuming Button component is already defined

const basePath = '/'; // Define the base path

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate(); // Initialize the navigate function

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <div className="text-center">
        <h1 className="text-5xl font-bold text-red-500">404 Not Found</h1>
        <p className="text-lg">The page you are looking for does not exist.</p>
        <div className="space-y-3">
        <Button onClick={() => navigate(`${basePath}`)}>Go to Home</Button>
           </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
